module.exports = __webpack_public_path__ + "img/weidu.e7038003.svg";